import React from 'react';

import { QuoteColumns } from './SelectQuoteBlock';

interface SelectQuoteLoaderRowProps {
    quoteColumns?: QuoteColumns | null;
    hideBookOrderButton?: boolean;
    /** Mirrors the header's trailing single-select radio column (interactive mode only). */
    showSelectColumn?: boolean;
    /** Read-only mode drops the trailing expired-rate action menu column from the header. */
    isReadOnly?: boolean;
}

const isColumnVisible = (quoteColumns: QuoteColumns | null | undefined, key: string) => quoteColumns?.[key] !== false;

const SelectQuoteLoaderRow = ({ quoteColumns, hideBookOrderButton = false, showSelectColumn = false, isReadOnly = false }: SelectQuoteLoaderRowProps) => (
    <>
        <td className="min-w-[82px] max-w-[82px]">
            <div className="custom-loading w-fit">Option 1</div>
        </td>
        {/* Carrier Name */}
        {isColumnVisible(quoteColumns, 'carrierName') && (
            <td className="min-w-[170px] max-w-[170px]">
                <div className="flex items-center gap-x-2">
                    <div className="custom-loading max-w-[120px]">Lorem Ipsum lorem</div>
                </div>
            </td>
        )}
        {/* Tags */}
        <td className="min-w-[100px] max-w-[100px]">
            <div className="custom-loading w-fit">Economy</div>
        </td>
        {/* Shipping Mode */}
        {isColumnVisible(quoteColumns, 'shippingMode') && (
            <td className="min-w-[82px] max-w-[82px]">
                <p className="text-textSecondary font-medium custom-loading">Lorem Ipsum</p>
            </td>
        )}
        {/* Service Level */}
        {isColumnVisible(quoteColumns, 'shippingServiceLevel') && (
            <td className="min-w-[108px] max-w-[108px]">
                <p className="text-textSecondary font-medium custom-loading">Lorem Ipsum</p>
            </td>
        )}
        {/* Transit Time */}
        {isColumnVisible(quoteColumns, 'transitTime') && (
            <td className="min-w-[108px] max-w-[108px]">
                <p className="text-textSecondary font-medium custom-loading">Est. 4 days</p>
            </td>
        )}
        {/* Total Cost */}
        <td className="min-w-[108px] max-w-[108px]">
            <p className="text-textSecondary font-medium custom-loading">$000.00 CAD</p>
        </td>
        {/* Selected-quote checkmark column — mirrors the header's trailing 'selectedIndicator' cell,
            dropped entirely until hideBookOrderButton (isToBookStatus) so the skeleton doesn't
            reserve an always-empty cell the real row also no longer renders pre-booking. */}
        {hideBookOrderButton && (
            <td className="w-[40px] min-w-[40px] max-w-[40px]">
                <div className="custom-loading w-4 h-4 rounded" />
            </td>
        )}
        {/* Trailing expired-rate action menu column — dropped in read-only mode or once booked
            (hideBookOrderButton), matching the header's now Order-ID-free trailing column. */}
        {!isReadOnly && !hideBookOrderButton && (
            <td className="w-[40px] min-w-[40px] max-w-[40px]">
                <div className="flex justify-end">
                    <div className="custom-loading w-4 h-4 rounded" />
                </div>
            </td>
        )}
        {/* Trailing single-select radio column — mirrors the header's trailing 'selectQuote' cell. */}
        {showSelectColumn && (
            <td className="!pl-2 w-[40px] min-w-[40px] max-w-[40px]">
                <div className="custom-loading w-4 h-4 rounded" />
            </td>
        )}
    </>
);

export default SelectQuoteLoaderRow;
